import React from 'react';
import PhotoGallery from './photoGallery.js'
import utils from "./utils.js";
import Footer from './components/footer.jsx'
import Nav from './components/nav.jsx'

import Logo from './components/logo.jsx'
/* styles */
import './styles/static.scss'
import './styles/themes.scss'
import "photoswipe/dist/photoswipe.css"
import "photoswipe/dist/default-skin/default-skin.css"
import "@fortawesome/fontawesome-free/css/all.min.css"

class App extends React.Component {

    constructor(props) {
      super(props)
  
      this.GID = 1
      window.myGlobals = {
        gallery: new PhotoGallery(this.GID)
      }
  
      //manual url change tracking is for analytics only
      this.previousUrl = {};
      let {pathname, search, hash, href} = document.location
      Object.assign(this.previousUrl, {pathname, search, hash, href})
    }
    componentDidMount() {
  
      this.props.history.listen((location, action) => {
  
        setTimeout(() => {
  
          //console.log(`detected history change:${action}`)
          if (this.UrlIsTheSame()) {
  
          } else {
  
            //copy and save location, send analytics:
            let {pathname, search, hash, href} = document.location
            Object.assign(this.previousUrl,{pathname, search, hash, href})
            utils.sendPageView();
          }
          
          let url = utils.parseUrlHash(location.hash)
  
          if (url.pid) {
            if (!window.myGlobals.gallery.loadGallery(url.pid)) {
              console.log("Photogallery encountered an error and did not load the image.")
              window.history.pushState("", document.title, window.location.pathname + window.location.search);//clears hash, adds history entry
            }
          } else if (url.localAnchorId) {
            utils.hashLinkScroll(url.localAnchorId);
          }
        }, 0)
      })
    }
  
    componentDidUpdate(prevProps) {
  
      if (this.props.location.pathname !== prevProps.location.pathname) {
        window.scrollTo(0, 0);
      }
    }
    render = () => {
      window.myGlobals && window.myGlobals.audioContext && (window.myGlobals.audioContext.close())
      return (
        <div id="layoutRoot">

          {/* Note: components like {Home} or {Code} inside a <Route></Route> get location prop automatically, but here we have to pass it in i guess. https://stackoverflow.com/a/42010806/244811*/}
          <Nav location={this.props.location} />
  
          <header>
            {this.props.location.pathname === "/" && !document.location.search ? (
              <Logo />
            ) : ("")
            }
          </header>
  
          <main>
            {this.props.children}
          </main>
  
          <Footer />
  
        </div>
      )
    }
    
    UrlIsTheSame = () => {
      //could really just be href
      return this.previousUrl 
      && this.previousUrl.pathname === document.location.pathname 
      && this.previousUrl.search === document.location.search 
      && this.previousUrl.hash === document.location.hash
    }
  
  }
  export default App